import "../report-styles/customSelect.scss";
import InfoBarSelection from "./infoBarSelection";
import DateRangePicker from "./dateRangePicker";
import SearchIcon from "../svgs/Search Duo.svg";
import React, { Component } from "react";
import { ClickAwayListener } from "@material-ui/core";
import { Dialog } from "@material-ui/core";
import { format, subDays, addDays } from "date-fns";
import { isObject } from "formik";
//import { he } from "date-fns/locale";

export default class CustomDatePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkboxSelection: {},
      localValues: [],
      searchTerm: "",
      dialogOpen: false,
    };
  }

  onDateChange = (e) => {
    this.props.onChangeDate(e);
    this.setState({ dialogOpen: false });
  };

  getDateRangeLimitConstraints = () => {
    const { item, report, form } = this.props;
    const dateRangeLimit = report?.dateRangeLimit;

    if (!dateRangeLimit)
      return { constrainedMinDate: null, constrainedMaxDate: null };

    let constrainedMinDate = null;
    let constrainedMaxDate = null;

    if (item.pairedWithStart) {
      const startDateValue =
        form && form[item.pairedWithStart]
          ? form[item.pairedWithStart].value
          : null;
      if (startDateValue) {
        constrainedMinDate = new Date(startDateValue);
        constrainedMaxDate = addDays(new Date(startDateValue), dateRangeLimit);
      }
    } else if (item.pairedWithEnd) {
      const endDateValue =
        form && form[item.pairedWithEnd]
          ? form[item.pairedWithEnd].value
          : null;
      if (endDateValue) {
        constrainedMaxDate = new Date(endDateValue);
        constrainedMinDate = subDays(new Date(endDateValue), dateRangeLimit);
      }
    }

    return { constrainedMinDate, constrainedMaxDate };
  };
  render() {
    // ${format(new Date(timeStamp),"h:mm b, cccc, MMMM LL")}
    const lastparsedDate = this.props.parserStatus
      ? this.props.parserStatus["last_parsed"]
      : null;
    const reportKey = this.props.reportKey;
    //console.log(reportKey);
    const item = this.props.item;
    const isRequired = this.props.fields
      ? this.props.fields.fields[item.key].is_required
      : false;

    const minDate = item.dynamicMinDate || item.minDate;

    const today = new Date();
    let maxDate;
    let lastParsedConstraint = null;

    if (lastparsedDate) {
      lastParsedConstraint = format(
        subDays(new Date(lastparsedDate), 1),
        "yyyy-MM-dd"
      );
    }

    if (item.dynamicMaxDate) {
      maxDate = item.dynamicMaxDate;
      lastParsedConstraint = null;
    } else if (lastParsedConstraint) {
      maxDate = lastParsedConstraint;
    } else {
      maxDate = item.maxDate || today;
    }

    const { constrainedMinDate, constrainedMaxDate } =
      this.getDateRangeLimitConstraints();

    let finalMinDate = minDate;
    let finalMaxDate = maxDate;

    if (constrainedMinDate) {
      finalMinDate =
        constrainedMinDate > new Date(minDate || "1900-01-01")
          ? constrainedMinDate
          : minDate;
    }

    if (constrainedMaxDate) {
      finalMaxDate =
        constrainedMaxDate < new Date(maxDate || "2100-01-01")
          ? constrainedMaxDate
          : maxDate;
    }

    return (
      <div
        className={"custom-select-container"}
        onClick={(e) => {
          e.stopPropagation();
          this.setState({ dialogOpen: true });
        }}
      >
        <InfoBarSelection
          item={item}
          values={
            item.value === "" ? [] : [new Date(item.value).toDateString()]
          }
          type="date"
          isRequired={isRequired}
        />

        {this.state.dialogOpen && (
          <Dialog
            aria-labelledby="simple-dialog-title"
            open={true}
            onClose={() => this.setState({ dialogOpen: false })}
          >
            <div className="custom-date-picker-report-container">
              <h2 className="custom-date-picker-header">{item.label}</h2>
              <p className="custom-date-picker-sub-header">
                {this.props.report.name}
              </p>
              <DateRangePicker
                onChangeDate={this.onDateChange}
                minDate={finalMinDate}
                maxDate={finalMaxDate}
                date={item.value}
                showMonthAndYearPickers={!lastParsedConstraint}
              />
            </div>
          </Dialog>
        )}
      </div>
    );
  }
}
